var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useEffect, useMemo, useRef, useReducer } from 'react';
import { getPaginationMeta } from './getPaginationMeta';
import { paginationStateReducer } from './paginationStateReducer';
export function usePagination(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.totalItems, totalItems = _c === void 0 ? 0 : _c, _d = _b.initialPage, initialPage = _d === void 0 ? 0 : _d, _e = _b.initialPageSize, initialPageSize = _e === void 0 ? 0 : _e;
    var initialState = {
        totalItems: totalItems,
        pageSize: initialPageSize,
        currentPage: initialPage,
    };
    var _f = useReducer(paginationStateReducer, initialState), paginationState = _f[0], dispatch = _f[1];
    var totalItemsRef = useRef(totalItems);
    totalItemsRef.current = totalItems;
    useEffect(function () {
        return function () {
            if (typeof totalItemsRef.current !== 'number' || totalItems === totalItemsRef.current) {
                return;
            }
            dispatch({ type: 'SET_TOTALITEMS', totalItems: totalItemsRef.current });
        };
    }, [totalItems]);
    return __assign(__assign(__assign({}, paginationState), useMemo(function () { return getPaginationMeta(paginationState); }, [paginationState])), { setPage: useCallback(function (page) {
            dispatch({
                type: 'SET_PAGE',
                page: page,
            });
        }, []), setNextPage: useCallback(function () {
            dispatch({ type: 'NEXT_PAGE' });
        }, []), setPreviousPage: useCallback(function () {
            dispatch({ type: 'PREVIOUS_PAGE' });
        }, []), setPageSize: useCallback(function (pageSize, nextPage) {
            if (nextPage === void 0) { nextPage = 0; }
            dispatch({ type: 'SET_PAGESIZE', pageSize: pageSize, nextPage: nextPage });
        }, []) });
}
